// extracted by mini-css-extract-plugin
export default {"container":"DT-z","dimension":"ET-z","dimensionLabels":"FT-z"};